module.exports = new Promise(resolve => {
    const script = document.createElement('script')
    script.src = window.mainUrls['Hookaholics']
    if (!script.src) {
      resolve({
        get: (request) => { throw new Error('Module Hookaholics URL not available') },
        init: (arg) => { throw new Error('Module Hookaholics URL not available') }
      })
      return
    }
    script.onload = () => resolve({
      get: (request) => window['Hookaholics'].get(request),
      init: (arg) => {
        try {
          return window['Hookaholics'].init(arg)
        } catch(e) {
          console.warn('remote container already initialized: Hookaholics')
        }
      }
    })
    script.onerror = () => resolve({
      get: (request) => { throw new Error('Module Hookaholics not available') },
      init: (arg) => { throw new Error('Module Hookaholics not available') }
    })
    document.head.appendChild(script);
  });